<template>
  <div>
    <ul class="invoice-details">
      <li>
        <div class="form-row">
          <label class="lb">INVOICE DATE</label>
          <div class="inputs">
            <date-picker format="DD/MM/YYYY" value-type="YYYY-MM-DD" v-model="postData.invoice_date" name="invoice_date" :editable="false"
                         input-class="form-control" style="display: block;width: 100%;"></date-picker>
          </div>
        </div>
        <div class="form-row">
          <label class="lb">CLIENT PO</label>
          <div class="inputs">
            <input type="text" class="form-control"  v-model="postData.client_po">
          </div>
        </div>
        <div class="form-row">
          <label class="lb">
            RELATED JOB
            <template v-if="postData.job_id">
              <br/>
              <router-link target="_blank" :to="{ name: 'job', params: { jobId: postData.job_id } }">Go to job</router-link>
            </template>
          </label>
          <div class="inputs">
            <v-select v-model="postData.job_id" :options="allJobs" class="form-control" :reduce="item => item.id"
                      label="name" :searchable="true" :placeholder="'- Select job'"></v-select>
          </div>
        </div>
      </li>
      <li>
        <div class="form-row">
          <label class="lb">SUPPLIER</label>
          <div class="inputs">
            <v-select v-model="postData.supplier_id" :options="allSuppliers" class="form-control" :reduce="item => item.id"
                      label="name" :searchable="true" :placeholder="'- Select supplier'"></v-select>
          </div>
        </div>
        <div class="form-row">
          <label class="lb">COMPANY</label>
          <div class="inputs">
            <v-select v-model="postData.client_id" :options="allClients" class="form-control" :reduce="item => item.id"
                      label="name" :searchable="true" :clearable="false"></v-select>
          </div>
        </div>
        <div class="form-row">
          <label class="lb">CONTACT</label>
          <div class="inputs">
            <v-select v-model="postData.contact_id" :options="clientContacts" class="form-control" :reduce="item => item.id"
                      label="full_name" :searchable="true" :clearable="true" :placeholder="'- Select contact'"></v-select>
          </div>
        </div>
      </li>
      <li>
        <div class="form-row">
          <label class="lb">TERMS</label>
          <div class="inputs">
            <v-select v-model="postData.terms" :options="invoiceTerms" class="form-control" :reduce="item => item.id"
                      label="name" :searchable="true"></v-select>
          </div>
        </div>
        <div class="form-row">
          <label class="lb">DATE PAID</label>
          <div class="inputs">
            <date-picker format="DD/MM/YYYY" value-type="YYYY-MM-DD" v-model="postData.paid_date" name="paid_date" :editable="false"
                         input-class="form-control" style="display: block;width: 100%;"></date-picker>
          </div>
        </div>
      </li>
    </ul>
    <ul class="invoice-details">
      <li class="two-col">
        <div class="form-row">
          <label class="lb">NOTE</label>
          <div class="inputs">
            <textarea-autosize :min-height="97" :max-height="100" class="form-control" v-model="postData.note"></textarea-autosize>
          </div>
        </div>
      </li>
      <li>
        <div class="text-right">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="button" class="btn btn btn-primary w180" @click="saveInvoice(null)">Save</button>
          </template>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import ServiceInvoice from '@/services/invoice'
import ServiceClient from '@/services/client'
import DatePicker from 'vue2-datepicker';
import BeatLoader from 'vue-spinner/src/BeatLoader'

export default {
  components: {
    DatePicker,
    BeatLoader
  },
  data () {
    return {
      state: '',
      updated_dtm: 0,
      postData: {
        invoice_date: '',
        job_id: '',
        client_id: '',
        contact_id: '',
        client_po: '',
        supplier_id: '',
        terms: '30',
        paid_date: '',
        note: ''
      },
      clientContacts: []
    }
  },
  watch: {
    'postData.job_id': function (newVal) {
      if(newVal) {
        let self = this;
        let job = window.getObjectByKeyValue(this.allJobs, 'id', newVal);
        if(job) {
          self.postData.client_id = job.client_id;
        }
      }
    },
    'postData.client_id': function (newVal) {
      this.getContacts(newVal);
    }
  },
  computed: {
    ...mapGetters(['INVOICE']),
    ...mapState({
      invoiceTerms: state => state.option.invoiceTerms,
      allJobs: state => state.option.jobs,
      allClients: state => state.option.clients,
      allSuppliers: state => state.option.suppliers
    })
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.populateData()
    },
    populateData () {
      let self = this;
      for(let f in self.postData){
        if(typeof self.INVOICE[f] != 'undefined')
          self.postData[f] = self.INVOICE[f];
      }
      if (self.postData.client_id)
        self.getContacts(self.postData.client_id);
    },
    saveInvoice (updateData) {
      let self = this;
      if (self.state == 'saving') {
        return;
      }
      if (updateData == null) {
        updateData = {};
        Object.assign(updateData, self.postData);
      }

      self.state = 'saving';
      ServiceInvoice.save(self.INVOICE.id, updateData, invoice => {
        let now = new Date().getTime();
        if(now - self.updated_dtm > 5*1000){
          self.$notify({
            type: 'success',
            text: 'Invoice updated'
          });
          self.updated_dtm = now;
        }
        self.state = '';
        self.$store.dispatch('UPDATE_INVOICE', invoice).then(() => {
          self.populateData();
        });
      }, () => {
        self.state = '';
      });
    },
    getContacts (clientId) {
      let self = this;
      ServiceClient.getMembers(clientId, {ipp: 'all'}, resp => {
        self.clientContacts = resp;
      });
    }
  }
}
</script>
